/* Cartec Essentials — kennisbank-zoeken op de contactpagina.
   1) [data-ce-kbsearch]: grote zoekbalk met live resultaten.
   2) [data-ce-kbsuggest]: suggesties onder het contactformulier terwijl de klant typt.
   Bron: de thema-index <script data-ce-kb> uit de header (titel t, categorie c,
   omschrijving d, url u). Zoekt op losse woorden, zodat ook een hele vraag als
   "hoe krijg ik vogelpoep van mijn lak" matcht. */
(function () {
  if (window.__ceKbSearch) return;
  window.__ceKbSearch = true;

  var STOP = ('de het een en of ik mijn je jij jouw u uw hoe wat waar wanneer welke welk wie waarom ' +
    'kan kun kunnen moet moeten mag is zijn ben was wordt worden word van voor met op in uit aan te om ' +
    'bij naar die dat dit deze er ook niet geen nog wel al als dan maar zo heel erg krijg krijgen ' +
    'maak maken doe doen gebruik gebruiken beste goed goede wil willen graag vraag hallo hoi beste').split(' ');

  // Synoniemen: klanten zeggen 'schoonmaken', artikelen 'reinigen' (en andersom).
  var SYN = [
    ['schoonmak', 'reinig', 'schoon', 'poets', 'wass'],
    ['verwijder', 'weghal', 'eraf', 'reinig'],
    ['vlek', 'vuil', 'aanslag'],
    ['auto', 'wagen'],
    ['krass', 'kras', 'swirl', 'polijst'],
    ['beschermen', 'bescherm', 'coating', 'wax'],
    ['ruit', 'glas', 'raam', 'ramen'],
    ['band', 'wiel', 'velg'],
    ['stoel', 'bekleding'],
    ['camper', 'caravan', 'kampeer'],
    ['motor', 'tweewiel', 'scooter', 'fiets']
  ];
  function alts(w) {
    var out = [w];
    SYN.forEach(function (g) {
      if (g.some(function (x) { return w.indexOf(x) === 0 || x.indexOf(w) === 0; })) {
        g.forEach(function (x) { if (out.indexOf(x) === -1) out.push(x); });
      }
    });
    return out;
  }

  var index = null;
  function getIndex() {
    if (index) return index;
    index = [];
    try {
      var raw = document.querySelector('[data-ce-kb]');
      if (raw) index = JSON.parse(raw.textContent || '[]');
    } catch (e) { index = []; }
    index.forEach(function (e) {
      e._t = norm(e.t); e._c = norm(e.c); e._d = norm(e.d);
    });
    return index;
  }

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Eenvoudige stam: meervoud/verbuiging eraf zodat "velgen" ook "velg" vindt.
  function stem(w) {
    if (w.length > 5 && /en$/.test(w)) return w.slice(0, -2);
    if (w.length > 4 && /[^s]s$/.test(w)) return w.slice(0, -1);
    return w;
  }

  function tokens(q) {
    return norm(q).split(/[^a-z0-9]+/).filter(function (w) {
      return w.length >= 3 && STOP.indexOf(w) === -1;
    }).map(stem);
  }

  function search(q, max) {
    var tk = tokens(q);
    if (!tk.length) return { tokens: tk, hits: [] };
    // Minstens de helft van de woorden moet matchen; volledige matches komen bovenaan.
    var need = Math.max(1, Math.ceil(tk.length / 2));
    var groups = tk.map(alts);
    var hits = [];
    getIndex().forEach(function (e) {
      var score = 0, matched = 0;
      groups.forEach(function (g) {
        var best = 0;
        g.forEach(function (w, i) {
          var exact = i === 0 ? 1 : 0.6; // synoniem telt iets minder
          var sc = 0;
          if (e._t.indexOf(w) !== -1) sc += 4;
          if (e._c.indexOf(w) !== -1) sc += 2;
          if (e._d.indexOf(w) !== -1) sc += 1;
          if (sc * exact > best) best = sc * exact;
        });
        if (best > 0) { matched++; score += best; }
      });
      if (matched >= need) hits.push({ e: e, m: matched, s: score });
    });
    hits.sort(function (a, b) { return (b.m - a.m) || (b.s - a.s); });
    return { tokens: tk, hits: hits.slice(0, max).map(function (h) { return h.e; }) };
  }

  // Markeer gevonden woorden in de titel (alleen als de positie 1-op-1 klopt).
  function highlight(title, tk) {
    var t = String(title || '');
    var n = norm(t);
    if (n.length !== t.length || !tk.length) return esc(t);
    var marks = [];
    tk.forEach(function (w) {
      var i = n.indexOf(w);
      while (i !== -1) { marks.push([i, i + w.length]); i = n.indexOf(w, i + w.length); }
    });
    if (!marks.length) return esc(t);
    marks.sort(function (a, b) { return a[0] - b[0]; });
    var out = '', pos = 0;
    marks.forEach(function (m) {
      if (m[0] < pos) return;
      out += esc(t.slice(pos, m[0])) + '<mark>' + esc(t.slice(m[0], m[1])) + '</mark>';
      pos = m[1];
    });
    return out + esc(t.slice(pos));
  }

  function itemHtml(e, tk) {
    return '<a class="ce-kbr__item" href="' + esc(e.u) + '">' +
      '<span class="ce-kbr__body">' +
      (e.c ? '<span class="ce-kbr__cat">' + esc(e.c) + '</span>' : '') +
      '<span class="ce-kbr__t">' + highlight(e.t, tk) + '</span></span>' +
      '<span class="ce-kbr__arrow" aria-hidden="true">→</span></a>';
  }

  /* ---------- 1) Grote zoekbalk ---------- */
  function bindSearch(form) {
    if (form.dataset.ceBound) return;
    form.dataset.ceBound = '1';
    var input = form.querySelector('[data-ce-kbsearch-input]');
    var box = form.querySelector('[data-ce-kbsearch-results]');
    var helpUrl = form.getAttribute('data-help-url') || '/pages/help';
    var anchor = form.getAttribute('data-contact-anchor') || '#contact';
    var timer = null;

    function hide() { box.hidden = true; }

    function render() {
      var q = input.value.trim();
      if (q.length < 2) { hide(); box.innerHTML = ''; return; }
      var r = search(q, 6);
      var html = '';
      if (r.hits.length) {
        html += '<div class="ce-kbr__title">Gevonden in de kennisbank</div>';
        r.hits.forEach(function (e) { html += itemHtml(e, r.tokens); });
        html += '<div class="ce-kbr__foot">' +
          '<a href="' + esc(helpUrl) + '?zoek=' + encodeURIComponent(q) + '">Alle tips bekijken →</a>' +
          '<a href="' + esc(anchor) + '" data-ce-kb-tocontact>Niet gevonden? Stel je vraag</a></div>';
      } else {
        html += '<div class="ce-kbr__empty"><strong>Geen artikel gevonden voor “' + esc(q) + '”.</strong>' +
          'Probeer een ander woord, of stel je vraag direct aan ons team.</div>' +
          '<div class="ce-kbr__foot"><a href="' + esc(helpUrl) + '">Blader door de kennisbank →</a>' +
          '<a href="' + esc(anchor) + '" data-ce-kb-tocontact>Naar het contactformulier ↓</a></div>';
      }
      box.innerHTML = html;
      box.hidden = false;
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(render, 150);
    });
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length >= 2) box.hidden = false; });

    // Enter: direct naar het beste resultaat als er precies één is, anders naar de kennisbank.
    form.addEventListener('submit', function (ev) {
      var r = search(input.value.trim(), 2);
      if (r.hits.length === 1) { ev.preventDefault(); window.location.href = r.hits[0].u; }
    });

    // Pijltjestoetsen door de resultaten.
    form.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') { hide(); input.focus(); return; }
      if (ev.key !== 'ArrowDown' && ev.key !== 'ArrowUp') return;
      var links = Array.prototype.slice.call(box.querySelectorAll('a'));
      if (box.hidden || !links.length) return;
      ev.preventDefault();
      var i = links.indexOf(document.activeElement);
      if (ev.key === 'ArrowDown') i = i < links.length - 1 ? i + 1 : 0;
      else i = i > 0 ? i - 1 : -1;
      if (i === -1) input.focus(); else links[i].focus();
    });

    // Doorverwijzing naar het formulier: zoekterm meenemen als onderwerp.
    box.addEventListener('click', function (ev) {
      var a = ev.target.closest('[data-ce-kb-tocontact]');
      if (!a) return;
      var subject = document.querySelector('[data-ce-kbsuggest-subject]');
      if (subject && !subject.value) subject.value = input.value.trim();
      hide();
    });

    document.addEventListener('click', function (ev) { if (!form.contains(ev.target)) hide(); });
  }

  /* ---------- 2) Suggesties in het contactformulier ---------- */
  function bindSuggest(box) {
    if (box.dataset.ceBound) return;
    box.dataset.ceBound = '1';
    var form = box.closest('form');
    if (!form) return;
    var fields = form.querySelectorAll('[data-ce-kbsuggest-src]');
    var list = box.querySelector('[data-ce-kbsuggest-list]');
    var timer = null;

    function update() {
      var q = Array.prototype.map.call(fields, function (f) { return f.value; }).join(' ').slice(0, 300);
      var r = search(q, 3);
      if (!r.hits.length) { box.hidden = true; return; }
      list.innerHTML = r.hits.map(function (e) { return itemHtml(e, r.tokens); }).join('');
      box.hidden = false;
    }

    Array.prototype.forEach.call(fields, function (f) {
      f.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(update, 400);
      });
    });
  }

  function init(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-ce-kbsearch]'), bindSearch);
    Array.prototype.forEach.call(root.querySelectorAll('[data-ce-kbsuggest]'), bindSuggest);
  }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
